import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

export interface PlatformServices {
  impact(kind: 'light' | 'medium' | 'heavy'): Promise<void>;
  notification(kind: 'success' | 'warning' | 'error'): Promise<void>;
}

export class CapacitorPlatformServices implements PlatformServices {
  async impact(kind: 'light' | 'medium' | 'heavy'): Promise<void> {
    if (!Capacitor.isNativePlatform()) return;
    const style =
      kind === 'light'
        ? ImpactStyle.Light
        : kind === 'medium'
          ? ImpactStyle.Medium
          : ImpactStyle.Heavy;
    await Haptics.impact({ style });
  }

  async notification(kind: 'success' | 'warning' | 'error'): Promise<void> {
    if (!Capacitor.isNativePlatform()) return;
    const type =
      kind === 'success'
        ? NotificationType.Success
        : kind === 'warning'
          ? NotificationType.Warning
          : NotificationType.Error;
    await Haptics.notification({ type });
  }
}
